(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["yg-anchor-item"] && !Shopify.designMode) return;
  try {
    class YGAnchorItem extends HTMLElement {
    static isScroll = false;
    static scrollCleanup = null;

    constructor() {
      super();
      this.itemClick = this.itemClick.bind(this);
      this.handleKeydown = this.handleKeydown.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleIntersect = this.handleIntersect.bind(this);
      this.sections = [];
      this.currentSection = null;
      this.targetElement = null;
      this.observer = null;
    }

    connectedCallback() {
      this.refreshSections();
      this.refreshTarget();
      this.addEventListener('click', this.itemClick);
      this.addEventListener('keydown', this.handleKeydown);
      window.addEventListener('resize', this.handleResize, { passive: true });
      this.setupObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.itemClick);
      this.removeEventListener('keydown', this.handleKeydown);
      window.removeEventListener('resize', this.handleResize);
      this.teardownObserver();
    }

    handleResize() {
      this.refreshSections();
      this.setupObserver();
    }

    handleKeydown(event) {
      if (event.key != 'Enter' && event.key != ' ') {
        return;
      }

      event.preventDefault();
      this.itemClick();
    }

    refreshTarget() {
      const sectionNumber = Number(this.getAttribute('data-section-number') || 0);

      if (!Number.isFinite(sectionNumber) || sectionNumber <= 0) {
        this.targetElement = null;
        return;
      }

      this.targetElement = this.sections[sectionNumber - 1] || null;
    }

    refreshSections() {
      const mainRoot =
        document.getElementById('MainContent') || document.getElementById('main') || document.querySelector('main');
      const allSections = mainRoot
        ? Array.from(mainRoot.querySelectorAll('.shopify-section'))
        : Array.from(document.querySelectorAll('.shopify-section'));
      this.currentSection = this.closest('.shopify-section');
      this.sections = allSections;
    }

    setupObserver() {
      this.refreshTarget();
      this.teardownObserver();

      if (!this.targetElement) {
        return;
      }

      const topOffset = this.getVisibleHeaderHeight() + this.getStickyHeight() + 12;
      const observerBandHeight = 24;
      const bottomOffset = Math.max(window.innerHeight - topOffset - observerBandHeight, 0);

      this.observer = new IntersectionObserver(this.handleIntersect, {
        root: null,
        threshold: 0.01,
        rootMargin: `-${topOffset}px 0px -${bottomOffset}px 0px`,
      });

      this.observer.observe(this.targetElement);
    }

    teardownObserver() {
      if (!this.observer) {
        return;
      }

      this.observer.disconnect();
      this.observer = null;
    }

    handleIntersect(entries) {
      entries.forEach((entry) => {
        if (!entry.isIntersecting || YGAnchorItem.isScroll) {
          return;
        }

        this.setActiveFromObserver();
      });
    }

    getGroupItems() {
      const id = this.getAttribute('data-id');

      if (id) {
        return Array.from(document.querySelectorAll(`yg-anchor-item[data-id="${id}"]`));
      }

      if (this.parentElement) {
        return Array.from(this.parentElement.querySelectorAll('yg-anchor-item'));
      }

      return [this];
    }

    setActiveFromObserver() {
      const currentSectionNumber = this.getAttribute('data-section-number') || '';

      this.getGroupItems().forEach((item) => {
        const isActive = item.getAttribute('data-section-number') === currentSectionNumber;

        item.classList.toggle('active', isActive);

        if (isActive) {
          item.setAttribute('aria-current', 'true');
          item.centerIntoView();
        } else {
          item.removeAttribute('aria-current');
        }
      });

      document.dispatchEvent(
        new CustomEvent('YG:anchor-change', {
          bubbles: true,
        })
      );
    }

    centerIntoView() {
      const parent = this.parentElement;

      if (!parent || parent.scrollWidth <= parent.clientWidth) {
        return;
      }

      const nextLeft = this.offsetLeft - Math.max((parent.clientWidth - this.offsetWidth) / 2, 0);

      parent.scrollTo({
        left: nextLeft,
        behavior: 'smooth',
      });
    }

    getVisibleHeaderHeight() {
      const header = document.querySelector('header.shopify-section-header-sticky:not(.shopify-section-header-hidden)');

      if (!header) {
        return 0;
      }

      return header.getBoundingClientRect().height;
    }

    getStickyHeight() {
      if (!this.currentSection) {
        return 0;
      }

      return this.currentSection.getBoundingClientRect().height;
    }

    itemClick() {
      this.refreshSections();
      this.refreshTarget();

      if (!this.targetElement) {
        return;
      }

      const offsetTop =
        this.targetElement.getBoundingClientRect().top +
        window.pageYOffset -
        this.getVisibleHeaderHeight() -
        this.getStickyHeight() -
        12;
      const targetScrollTop = Math.max(offsetTop, 0);

      YGAnchorItem.isScroll = true;
      this.setActiveFromObserver();

      window.scrollTo({
        top: targetScrollTop,
        behavior: 'smooth',
      });

      this.waitForScrollEnd(targetScrollTop);
    }

    waitForScrollEnd(targetScrollTop) {
      if (YGAnchorItem.scrollCleanup) {
        YGAnchorItem.scrollCleanup();
      }

      let frame = null;
      let timeout = null;
      let lastScrollTop = window.scrollY;
      let stillFrames = 0;

      const cleanup = () => {
        if (frame) {
          window.cancelAnimationFrame(frame);
        }

        if (timeout) {
          window.clearTimeout(timeout);
        }

        window.removeEventListener('scrollend', finish);

        if (YGAnchorItem.scrollCleanup === cleanup) {
          YGAnchorItem.scrollCleanup = null;
        }
      };

      const refreshGroupObservers = () => {
        this.getGroupItems().forEach((item) => {
          item.refreshSections();
          item.setupObserver();
        });
      };

      const finish = () => {
        cleanup();
        YGAnchorItem.isScroll = false;
        refreshGroupObservers();
      };

      const checkScrollPosition = () => {
        const currentScrollTop = window.scrollY;
        const reachedTarget = Math.abs(currentScrollTop - targetScrollTop) <= 2;
        const hasStopped = Math.abs(currentScrollTop - lastScrollTop) <= 0.5;

        stillFrames = hasStopped ? stillFrames + 1 : 0;
        lastScrollTop = currentScrollTop;

        if (reachedTarget || stillFrames >= 8) {
          finish();
          return;
        }

        frame = window.requestAnimationFrame(checkScrollPosition);
      };

      YGAnchorItem.scrollCleanup = cleanup;
      window.addEventListener('scrollend', finish, { once: true });
      timeout = window.setTimeout(finish, 4000);
      frame = window.requestAnimationFrame(checkScrollPosition);
    }
  }

  if (!window.customElements.get('yg-anchor-item')) {
    window.customElements.define('yg-anchor-item', YGAnchorItem);
  }
  } catch(e) { console.error(e); }
})();

})();
